import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import { useEffect } from "react";
import { getDatabase, ref, onDisconnect, set, onValue } from "firebase/database";
import { auth } from "./firebase"; // Your Firebase config



import { HelmetProvider } from 'react-helmet-async';

const root = createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Service Worker registration removed

// serviceWorkerRegistration.unregister(); // Removed to allow the manual register above

function PresenceListener() {
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const db = getDatabase();
    const uid = user.uid;
    const userStatusRef = ref(db, "/status/" + uid);

    const connectedRef = ref(db, ".info/connected");
    onValue(connectedRef, (snap) => {
      if (snap.val() === false) return;

      // Auto set to offline on disconnect
      onDisconnect(userStatusRef).set("offline").then(() => {
        // Set to online now
        set(userStatusRef, "online");
      });
    });
  }, []);

  return null;
}

export default PresenceListener;
